import { render, staticRenderFns } from "./ModalIntegrantesEquipeProfissional.vue?vue&type=template&id=785de9c6"
import script from "./ModalIntegrantesEquipeProfissional.vue?vue&type=script&lang=ts"
export * from "./ModalIntegrantesEquipeProfissional.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports